import { render, staticRenderFns } from "./productBox2.vue?vue&type=template&id=26865a91&scoped=true"
import script from "./productBox2.vue?vue&type=script&lang=js"
export * from "./productBox2.vue?vue&type=script&lang=js"
import style0 from "./productBox2.vue?vue&type=style&index=0&id=26865a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26865a91",
  null
  
)

export default component.exports